export default __webpack_public_path__ + "static/ut-diagram-53818832130a416a98ae2f59e44f51ce.svg";